// load jquery and foundation in the window scope

import 'core-js';

import 'what-input';
import 'foundation-sites/dist/js/foundation.js'; // foundation should now be imported on a case by case basis
import 'foundation-datepicker/js/foundation-datepicker';

import 'core-js/stable';
import 'regenerator-runtime/runtime';


import 'classes';
import 'initializers';
import bindRevealEvents from 'initializers/foundation_reveal';
document.addEventListener('DOMContentLoaded', () => {
  $(document).foundation();
  $('body').attr('data-foundation', true);
  $('body').addClass('load');
  bindRevealEvents();

  $('.burger').click(function () {
    $(this).toggleClass('active');
    $('.menu').toggleClass('active');
    $('body').toggleClass('stop-scroll');
  });

  $('[data-dropdown-menu-link]').click(function () {
    if ($(document).width() < 768) {
      if (!$(this).next().hasClass('active-mobile')) {
        $(this).next().addClass('active-mobile');
      } else {
        $(this).next().removeClass('active-mobile');
      }
    }
  });

  var inputs = document.querySelectorAll('.form-row input[type="file"]');
  Array.prototype.forEach.call(inputs, function (input) {
    var label = input.nextElementSibling;
    var labelVal = label ? label.innerHTML : '';

    if (label) {
      input.addEventListener('change', function (e) {
        var fileName = '';
        fileName = e.target.value.split('\\').pop();

        const labelSpan = label.querySelector('span');
        if (fileName && labelSpan) {
          labelSpan.innerHTML = fileName;
        } else {
          label.innerHTML = labelVal;
        }
      });
    }
  });
});
